import storage from './storage';
import { TEAM_KEYS, migratePrivateBucketsToTeam } from '../utils/teamCrmStore';

function key() {
  return TEAM_KEYS.meetings;
}

export const meetingService = {
  getAll(_userId) {
    void _userId;
    migratePrivateBucketsToTeam();
    return storage.get(key(), []);
  },

  saveAll(_userId, meetings) {
    void _userId;
    storage.set(key(), meetings);
  },
};
